import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable'
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader';
import ReadOnlyLiteratureTable from '../LiteratureTable/ReadOnlyLiteratureTable';
import '../../AddInterpretation/index.css'

const columns = [
  { id: 'category', label: 'Category', type: 'noSort' },
  { id: 'evaluation', label: 'Evaluation', type: 'noSort' },
  { id: 'comment', label: 'Comment', type: 'noSort' },
];

function createData(category, evaluation, comment) {
  return { category, evaluation, comment};
}

const evalColumn = [
  { id: 'classification', label: 'Classification', type: 'noSort' },
  { id: 'comments', label: 'Comment', type: 'noSort' },
];

function createEvalColumnData(classification, comments){
  return {classification, comments}
}

export default function FinalReview(props) {
  const categories = props.categoryValues;
  const programClassification = props.programClassification;
  const comment = props.comments;
  const evalRows = [
    createEvalColumnData(programClassification, comment)
  ]

  const rows = [
    createData('Population Frequency', categories['POPULATION_FREQUENCY'].eval, categories['POPULATION_FREQUENCY'].comments),
    createData('Disease Databases', categories['DISEASE_DATABASES'].eval, categories['DISEASE_DATABASES'].comments),
    createData('Computational Predictive Programs', categories['COMPUTATIONAL_PREDICTIVE_PROGRAMS'].eval, categories['COMPUTATIONAL_PREDICTIVE_PROGRAMS'].comments),
    createData('Nucleotide Conservation', categories['NUCLEOTIDE_CONSERVATION'].eval, categories['NUCLEOTIDE_CONSERVATION'].comments),
  ];

  return (
    <>
      <StyledPaper>
        <TableContainer>
          <StyledTable
            size='small'
            aria-label="final review table" >
            <MuiTableHeader 
              headCells={columns} 
            />
            <TableBody>
            {rows.map((row, index) => {
                return (
                  <StyledTableRow hover tabIndex={-1} key={index}>
                    {columns.map((column, index) => {
                      let value = row[column.id];
                      if (column.id === 'evaluation' && Array.isArray(value)) {
                        value = value.join(', ');
                      }
                      return (
                        <StyledTableCell style={{width: '33%'}} key={index} align={column.align}>
                          {column.format && typeof value === 'number' ? column.format(value) : value}
                        </StyledTableCell>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </StyledPaper>
      <br />
      <hr />
      <h3>Classification Summary</h3>
      <StyledPaper>
        <TableContainer>
          <StyledTable 
            size='small'
            aria-label="classification summary table" >
            <MuiTableHeader 
              headCells={evalColumn} 
            />
            <TableBody>
            {evalRows.map((row, index) => {
                  return (
                    <StyledTableRow hover tabIndex={-1} key={index}>
                      {evalColumn.map((column, index) => {
                        const value = row[column.id];
                        return (
                          <StyledTableCell style={{width: '50%'}} key={index} align={column.align}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                          </StyledTableCell>
                        );
                      })}
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </StyledPaper>
       <br />
      <hr />
      <h3>Literature Included in Your Report</h3>
      <ReadOnlyLiteratureTable  variantInterpretationId={props.variantInterpretationId}   />
      
    </>
  );
}